"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _constants = require("../../constants");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledFormControlLabel = (0, _styles.withStyles)(() => ({
  root: {
    height: 45,
    width: 70,
    padding: '13px 18px 12px 19px',
    fontFamily: _constants.fonts.normal,
    fontSize: _constants.fontSizes.subtitle2,
    color: _constants.colours.darkGrey,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    cursor: 'pointer',
    border: `1px solid ${_constants.colours.mediumGrey}`,
    margin: '0px 0px 0px 0px',
    '&:hover:not(.activeCheckbox)': {
      border: `1px solid ${_constants.colours.black}`,
      color: _constants.colours.black
    },
    '& .MuiTouchRipple-root, & .MuiSvgIcon-root, & .MuiIconButton-root': {
      display: 'none'
    },
    '&.activeCheckbox': {
      backgroundColor: _constants.colours.multiSelect,
      color: _constants.colours.white,
      '&:hover': {
        backgroundColor: _constants.colours.lightBlue,
        color: _constants.colours.white
      }
    },
    '&:last-child': {
      borderTopRightRadius: '5px',
      borderBottomRightRadius: '5px'
    },
    '&:first-child': {
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px'
    }
  }
}))(_core.FormControlLabel);

const MultiDaySelector = ({
  data,
  onHandleChange
}) => {
  return /*#__PURE__*/_react.default.createElement(_core.FormGroup, {
    row: true
  }, data.map(dataItem => /*#__PURE__*/_react.default.createElement(StyledFormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: dataItem.checked,
      onChange: onHandleChange,
      name: dataItem.name,
      color: "primary"
    }),
    label: dataItem.name,
    key: dataItem.key,
    className: dataItem.checked ? 'activeCheckbox' : ''
  })));
};

MultiDaySelector.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    checked: _propTypes.default.bool
  })).isRequired,
  onHandleChange: _propTypes.default.func
};
MultiDaySelector.defaultProps = {
  onHandleChange: null
};
var _default = MultiDaySelector;
exports.default = _default;